/* global jQuery */
import LinkSanitizer from './link-sanitizer';

;(function ($) {
  $.fn.shopgateLinkSanitizer = function (o) {
    const sanitizer = new LinkSanitizer(o);

    return this.each(function () {
      const links = $(this).find('a');

      links.each((index, el) => {
        sanitizer.sanitizeJQueryElement(el);
      });
    });
  };
})(jQuery);




// WEBPACK FOOTER //
// ./Library/1.0/common/jquery.shopgate-link-sanitizer.js